module.exports = __webpack_public_path__ + "static/media/code-branch.e4877c18.svg";